(function () {
  "use strict";

  const wrapper = document.querySelector(
    "[data-announcement-wrapper].announcement__wrapper--top",
  );

  if (!wrapper) return;

  const mobileQuery = window.matchMedia("(max-width: 767px)");

  function setAnnouncementHeight() {
    const height = wrapper.offsetHeight;

    if (!height) return;

    const property = mobileQuery.matches
      ? "--announcement-height-mobile"
      : "--announcement-height-desktop";

    document.documentElement.style.setProperty(property, `${height}px`);
  }

  const updateHeight = window.theme?.debounce
    ? window.theme.debounce(setAnnouncementHeight, 50)
    : setAnnouncementHeight;

  if (typeof ResizeObserver !== "undefined") {
    new ResizeObserver(updateHeight).observe(wrapper);
  }

  window.addEventListener("load", setAnnouncementHeight);
  document.addEventListener("theme:resize", updateHeight);
  document.addEventListener("shopify:section:load", setAnnouncementHeight);

  if (document.fonts?.ready) {
    document.fonts.ready.then(setAnnouncementHeight);
  }

  setAnnouncementHeight();
})();
